export default function (val, currency) {
  const c = currency || 'USD'
  const l = navigator.languages[0] || 'en-US'
  return new Intl.NumberFormat(l, { style: 'currency', currency: c }).format(val)
}
